import { useMutation, useQueryClient } from 'react-query';
import { loan_request_api } from '@axo/shared/data-access/api';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { loan_request, loan_application } from '@axo/shared/data-access/types';
import { useAPI } from '@axo/shared/data-access/provider';

export function useCancelRequest(
  application: loan_application.LoanApplication,
  requestID: string
) {
  const client = useQueryClient();
  const api = useAPI();
  return useMutation(
    () =>
      loan_request_api.patch(api)(requestID, {
        Status:
          loan_request.LoanRequestStatus
            .LoanRequestStatusApplicationCompletedNotRegistered,
      }),
    {
      onSuccess: () =>
        client.invalidateQueries(
          applicationKeys.loanQuotes({
            applicationID: application.ID,
          })
        ),
    }
  );
}
